export type LogLevel = 'debug' | 'verbose' | 'info' | 'warn' | 'error' | 'fatal';

export const SEVERITY: Record<LogLevel, number> = {
  debug: 1,
  verbose: 2,
  info: 3,
  warn: 4,
  error: 5,
  fatal: 6,
};

export const LEVEL_NAMES: Record<number, string> = {
  1: 'debug',
  2: 'verbose',
  3: 'info',
  4: 'warn',
  5: 'error',
  6: 'fatal',
};

export interface LogEntry {
    dt: string;
    level: string;
    severity: number;
    message: string;
    category: string;
    applicationName: string;
    subsystemName: string;
    threadId?: string;
    methodName?: string;
    className?: string;
}

export type SendLogsFn = (logs: LogEntry[]) => Promise<void>;

export interface TransportConfig {
  ingestUrl: string;
  token: string;
  /** Optional custom sender. If not provided, auto-selects based on environment (superagent in Node.js, fetch in browser). */
  sendLogs?: SendLogsFn;
  /** Optional proxy getter for Node.js superagent sender. */
  getProxy?: () => string | undefined;
  flushIntervalMs?: number;
  maxBufferSize?: number;
}
